import * as React from 'react';
import { useSelector } from 'react-redux';

import { LinkToFullVersion } from '../../components/LinkToFullVersion';
import { selectEventCategory } from '../../selectors/eventCategory';
import { IApplicationState } from '../../types/redux';
import { trackSiteTypeChange } from './tracking';

interface ILinkToFullVersionContainerProps {
  isRedesign?: boolean;
}

export const LinkToFullVersionContainer: React.FC<ILinkToFullVersionContainerProps> = ({ isRedesign }) => {
  const showSiteTypeChanging = useSelector((state: IApplicationState) => state.showSiteTypeChanging);
  const eventCategory = useSelector(selectEventCategory);
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const shouldUseRedesign = mounted ? isRedesign : false;

  const handleSiteTypeChange = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    trackSiteTypeChange(eventCategory);

    document.cookie = 'flavour=desktop;path=/;domain=.cian.ru';
    location.reload();
  };

  if (!showSiteTypeChanging) {
    return null;
  }

  return <LinkToFullVersion onClick={handleSiteTypeChange} isRedesign={shouldUseRedesign} />;
};
